module.exports = __webpack_public_path__ + "img/fan_autoset.449d979f.svg";